export default function ServicesGridSection() {
  return (
    <section className="w-full bg-background-100 py-20 md:py-28">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        {/* Top area: title + paragraph */}
        <div className="flex flex-col lg:flex-row lg:items-start gap-8 mb-14 md:mb-20">
          <div className="lg:w-[35%]">
            <h2 className="font-heading text-[2.2rem] md:text-[2.8rem] lg:text-[3rem] leading-[1.1] tracking-[-0.01em] text-foreground-950">
              Engineering
              <br />
              Services
            </h2>
          </div>
          <div className="lg:w-[65%] lg:pt-3 lg:text-right">
            <p className="font-body text-sm md:text-[15px] leading-relaxed text-foreground-600 max-w-[520px] lg:ml-auto">
              The team follows modern software engineering practices including clean architecture,
              performance optimization, and user-centered design. Every solution is built to meet
              the highest standards of the iOS platform.
            </p>
          </div>
        </div>

        {/* Three-column grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {/* Left card - wider, dark */}
          <div className="md:col-span-1 bg-primary-800 rounded-[28px] p-8 md:p-10 flex flex-col">
            <h3 className="font-body text-white text-lg md:text-xl font-semibold leading-tight">
              System Architecture
            </h3>
            <p className="text-sm text-foreground-300/70 mt-3 leading-relaxed">
              Designing robust, layered architectures that separate concerns and enable
              independent evolution of system components.
            </p>
            <div className="flex-1 mt-8 relative min-h-[160px]">
              <div className="absolute inset-0 opacity-15 rounded-2xl"
                style={{
                  background: 'repeating-linear-gradient(0deg, oklch(0.5 0.01 230) 0px, oklch(0.5 0.01 230) 1px, transparent 1px, transparent 20px), repeating-linear-gradient(90deg, oklch(0.5 0.01 230) 0px, oklch(0.5 0.01 230) 1px, transparent 1px, transparent 20px)',
                }}
              />
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-24 h-24 rounded-full opacity-25"
                style={{
                  background: 'radial-gradient(circle, oklch(0.6 0.02 230) 0%, transparent 70%)',
                }}
              />
            </div>
          </div>

          {/* Middle card - light */}
          <div className="bg-background-50 rounded-[28px] p-8 md:p-10 border border-background-300/50 flex flex-col items-center text-center">
            <span className="text-[11px] uppercase tracking-[0.12em] text-foreground-500/60 font-label self-start">
              Platform
            </span>
            <div className="flex-1 flex flex-col items-center justify-center my-8">
              <div className="w-28 h-28 rounded-full mb-6"
                style={{
                  background: 'radial-gradient(circle at 40% 35%, oklch(0.75 0.03 85) 0%, oklch(0.6 0.02 80) 40%, oklch(0.45 0.01 80) 100%)',
                  opacity: 0.7,
                }}
              />
              <h3 className="font-heading text-2xl md:text-3xl text-foreground-950 leading-tight">
                iOS Core
              </h3>
              <p className="text-sm text-foreground-500 mt-3 leading-relaxed max-w-[220px]">
                Deep expertise in native iOS development, leveraging platform capabilities
                for optimal performance and user experience.
              </p>
            </div>
          </div>

          {/* Right card - light */}
          <div className="bg-background-50 rounded-[28px] p-8 md:p-10 border border-background-300/50 flex flex-col items-center text-center">
            <span className="text-[11px] uppercase tracking-[0.12em] text-foreground-500/60 font-label self-start">
              Quality
            </span>
            <div className="flex-1 flex flex-col items-center justify-center my-8">
              <div className="w-28 h-28 rounded-full mb-6 relative"
                style={{
                  background: 'radial-gradient(circle at 55% 40%, oklch(0.7 0.025 95) 0%, oklch(0.55 0.015 90) 40%, oklch(0.4 0.01 85) 100%)',
                  opacity: 0.7,
                }}
              />
              <h3 className="font-heading text-2xl md:text-3xl text-foreground-950 leading-tight">
                Engineering
                <br />
                Standards
              </h3>
              <p className="text-sm text-foreground-500 mt-3 leading-relaxed max-w-[220px]">
                Adoption of up-to-date engineering practices ensuring reliable,
                future-ready solutions that stand the test of time.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}